/* Stylesheet */

.boolean_select {
  display: flex;
  width: 100%;
}
